export default __webpack_public_path__ + "static/media/3t.44ffd911.jpg";